import moment from 'moment'

import { IAppointment, IRepeatDetails } from '../../types'
import { IAPIAppointment } from '../../types/api'

import { apiAppointmentActivityTransformer } from './apiAppointmentActivityTransformer'
import { reminderStatusTransformer } from './reminderStatusTransformer'

export const apiAppointmentTransformer = (
  apiAppointment: IAPIAppointment,
): IAppointment => {
  const customerBirthday: string | null = apiAppointment.customer.birthday
  const isBirthday: boolean = customerBirthday
    ? moment(customerBirthday).isBetween(
        moment().subtract(7, 'days'),
        moment().add(7, 'days'),
      )
    : false

  const repeatDetails: IRepeatDetails | null = apiAppointment.is_repeat
    ? {
        startsAt: moment(apiAppointment.repeat_started_at),
        stopsAt: moment(apiAppointment.repeat_stops_at),
        weekInterval: apiAppointment.repeat_week_interval,
      }
    : null

  return {
    appointmentId: apiAppointment.id,
    uuid: apiAppointment.uuid,
    startsAt: moment(apiAppointment.starts_at),
    endsAt: moment(apiAppointment.ends_at),
    customer: {
      id: apiAppointment.customer.id,
      uuid: apiAppointment.customer.uuid,
      firstName: apiAppointment.customer.first_name,
      lastName: apiAppointment.customer.last_name,
    },
    customerRemarks: apiAppointment.appointment_customer_remarks,
    appointmentNotes: apiAppointment.notes || '',
    isOnlineBooked: apiAppointment.is_online,
    isBirthDay: isBirthday,
    paymentStatus: apiAppointment.payment_status || null,
    reminderStatus: reminderStatusTransformer(apiAppointment.reminder_status),
    remark: apiAppointment.remark || null,
    repeatDetails,
    appointmentActivity: apiAppointment.appointment_activities.map(
      apiActivity =>
        apiAppointmentActivityTransformer(apiActivity, apiAppointment.id),
    ),
  }
}
